import { MaterialCommunityIcons } from '@expo/vector-icons'
import { useTheme } from '../../hooks/useTheme'

/** A fixed, centred icon box shared by the account's collapsible tiles. */
export function SettingsDisclosureArrow({ expanded }: { expanded: boolean }) {
  const { theme } = useTheme()
  return <MaterialCommunityIcons name={expanded ? 'chevron-up' : 'chevron-down'} size={24}
    color={theme === 'dark' ? '#e6e1c4' : '#18170f'}
    accessible={false} style={{ width: 24, height: 24, lineHeight: 24, textAlign: 'center' }} />
}
